export default __webpack_public_path__ + "static/media/activity-5.64cb02af.png";